import { createContext, useContext } from 'react';

const AppLayoutContext = createContext(false);

export function AppLayoutChromeProvider({ children }) {
  return (
    <AppLayoutContext.Provider value={true}>
      {children}
    </AppLayoutContext.Provider>
  );
}

export function useIsInsideAppLayout() {
  return useContext(AppLayoutContext);
}
